<template>
  <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="loading.page"
  >
    <a-row :gutter="12">
      <a-form class="margin-bottom" :form="form">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
        <a-form-item label="Receive From">
          <a-input
            v-decorator="['receive_from', { rules: [{ required: true }],
            initialValue: initialData.receive_from, }]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Currency From">
          <a-select
            showSearch
            v-decorator="[
              'currency_from',
              {
                rules: [{ required: true }],
                initialValue: initialData.currency_from,
              },
            ]"
            placeholder="Select Currency"
            ref="currency_from"
            @change="handleMataUangCF"
            disabled
          >
            <a-select-option
              v-for="item in currencyList"
              :key="item.value"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Account From">
          <a-input
            v-decorator="['account_from', { rules: [{ required: true }],
            initialValue: initialData.account_from, }]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Value Refund">
          <a-input-number
            class="m-width-full"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="[
              'value_refund',
              {
                rules: [{ required: true }, { validator: checkMaxValue }],
                initialValue: initialData.value_refund,
              },
            ]"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="Date of Transfer">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="[
              'date_transfer',
              {rules: [{ required: true }],
                initialValue: initialData.date_transfer,},]"
          />
        </a-form-item>
        <a-form-item label="Value Cost Refund">
          <a-input-number
            class="m-width-full"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            :min="0"
            v-decorator="[
              'value_cost_refund',
              {
                rules: [{ required: true }],
                initialValue: initialData.value_cost_refund,
              },
            ]"
          ></a-input-number>
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
        <a-form-item label="Currency To">
          <a-select
            showSearch
            v-decorator="[
              'currency_to',
              {
                rules: [{ required: true }],
                initialValue: initialData.currency_to,
              },
            ]"
            placeholder="Select Currency"
            ref="currency_to"
            @change="handleMataUangCT"
          >
            <a-select-option
              v-for="item in currencyList"
              :key="item.value"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Account To">
          <a-select
            showSearch
            allowClear
            option-filter-prop="children"
            :filter-option="filterOption"
              v-decorator="['account_to', { rules: [{ required: true }],
                initialValue: initialData.account_to, }]"
            placeholder="Select Account to"
          >
            <a-select-option
              v-for="item in accountToList"
              :key="item.kode_rekening"
              :value="item.value"
            >{{item.text}}</a-select-option> 
          </a-select>
        </a-form-item>
        <a-form-item label="Kurs">
          <a-input-number
            class="m-width-full"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="[
              'kurs',
              {
                rules: [{ required: true }],
                initialValue: initialData.kurs,
              },
            ]"
            ref="kurs"
            @change="handlekurs"
            :disabled="kurscomparedisabled"
          ></a-input-number>
        </a-form-item>
        <a-form-item :label="currencyConvertion ? 'Value Receive ('+currencyConvertion+')' : 'Value Receive'">
          <a-input-number
            class="m-width-full"
            :formatter="
              (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="[
              'value_receive',
              {
                rules: [{ required: true }],
                initialValue: initialData.value_receive,
              },
            ]"
            ref="value_receive"
            @change="handleConvertion"
          ></a-input-number>
          <div v-if="valueConvertion" class="m-form-description-small">
              Value Convertion : {{formatCurrency($refs.currency_from.value,valueConvertion)}}
          </div>
        </a-form-item>
        <a-form-item label="Evidence Transfer">
          <a-upload
            :showUploadList="true"
            :fileList="push"
            :beforeUpload="beforeUpload"
            :remove="handleRemove"
            v-decorator="['evidence_transfer', { rules: [{ required: true, validator: validateUpoadFile }], 
            valuePropName: 'push' }]"
          >
            <a-button> <a-icon type="upload" />&nbsp;Select File</a-button>
          </a-upload>
        </a-form-item>
      </a-col>
      </a-form>
    </a-row>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "Detail-refundPayment",
  props: {
    type: String,
    dataProcessed: {},
    detilPO: {},
    isModifiedDtl: {},
    currencyList: {},
    accountToListOri: {},
  },
  mixins: [CurrencyFormat, GlobalMethod],
  components: {},
  data() {
    return {
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      loading:{
        page: false,
      },
      accountToList: [],
      kurscomparedisabled: false,
      push: [],
      valueConvertion: undefined,
      currencyConvertion: undefined,
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
    ]),
    initialData() {
      if(this.dataProcessed.value_refund){
        return this.dataProcessed.value_refund;
      }else{
        return {
          receive_from: undefined,
          currency_from: this.dataProcessed.information.nopowo.currency,
          account_from: undefined,
          value_refund: undefined,
          date_transfer: undefined,
          value_cost_refund: 0,
          currency_to: undefined,
          account_to: undefined,
          kurs: undefined,
          value_receive: undefined,
          push: [],
        }
      }
    },
  },
  methods: {
    checkMaxValue(rule, value, callback) {
      if (value <= this.dataProcessed.information.valueAP) {
        callback();
        return;
      }
      let formval = this.form.getFieldsValue();
      callback("Max. "+this.formatCurrency(formval.currency_from,this.dataProcessed.information.valueAP)+"!");
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handlekurs(val){
      this.handleConvertion(this.$refs.value_receive.value,val,val,this.$refs.currency_to.value);
    },
    handleMataUangCF(val){
      this.handlekurscomparedisabled(val,this.$refs.currency_to.value);
      this.handleConvertion(this.$refs.value_receive.value,this.$refs.kurs.value,val,this.$refs.currency_to.value);
    },
    handleMataUangCT(val){
      this.form.setFieldsValue({
        account_to: null,
      });
      this.accountToList = _.filter(this.accountToListOri, (item) => item.currency.toLowerCase()===(val ? val.toLowerCase() : null));
      this.handlekurscomparedisabled(this.$refs.currency_from.value,val);
      this.handleConvertion(this.$refs.value_receive.value,this.$refs.kurs.value,this.$refs.currency_from.value,val);
    },
    handlekurscomparedisabled(cf,ct){
      if(ct)
        this.currencyConvertion = ct;
      if(cf==ct){
        this.form.setFieldsValue({
          kurs: "1",
        });
        this.kurscomparedisabled = true;
      }else{
        this.kurscomparedisabled = false;
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
          this.push = [file];
        return false;
      }
    },
    handleRemove() {
        this.push = [];
    },
    validateUpoadFile(rule, value, callback){
      if (this.push.length > 0) {
        callback();
        return;
      }
      // uncomment untuk return false muncul
      callback("Upload File Support is required!");
    },
    handleConvertion(val,kurs,currency_from,currency_to){
      kurs = kurs ? kurs : this.$refs.kurs.value;
      currency_from = currency_from ? currency_from : this.$refs.currency_from.value;
      currency_to = currency_to ? currency_to : this.$refs.currency_to.value;
      //console.log(val,kurs,currency_from,currency_to)
      if(val){
        if(val!=null && kurs!=null && currency_to!=null 
          && currency_from!=null){
          if(currency_from==currency_to){
            this.valueConvertion = null;
          } else if(currency_to!="IDR"){
            this.valueConvertion = val*kurs;
          }else{
            this.valueConvertion = val/kurs;
          }
        } else{
          this.valueConvertion = null;
        }
      }
    },
    handleRef(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }else{
          if(values.value_refund+(values.value_cost_refund?values.value_cost_refund:0) 
                > this.dataProcessed.information.valueAP){
            this.displayMessageValue("error-other", "Max (Value Refund + Value Cost Refund) value is "+
              this.formatCurrency(values.currency_from,this.dataProcessed.information.valueAP));
            return;
          }else{
            Event.$emit("rp_infoData", {
                value_refund: values,
            });
          }
        }
      });
    },
    backhandleRef(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }else{
          Event.$emit("rp_infoDataB", {
              value_refund: values,
          });
        }
      });
    },
  },
  watch: {
  },
  mounted() {
    if(this.dataProcessed.value_refund){
        this.push = this.dataProcessed.value_refund.evidence_transfer.fileList;
        this.form.setFieldsValue({
          evidence_transfer: this.dataProcessed.value_refund.evidence_transfer,
        });
        this.accountToList = _.filter(this.accountToListOri, (item) => 
          item.currency.toLowerCase()===(this.dataProcessed.value_refund.currency_to.toLowerCase()));
    }
  },
  created(){
    this.form = this.$form.createForm(this);
  },
  beforeDestroy() {
  },
  beforeCreate() {
  },
};
</script>

<style lang="less">
</style>